import React, { useState, useEffect } from "react";
import ConfirmModal from "../../ui/Modal/ConfirmModal";
import { TeasersCountService, BatchStatusChangeService } from "../../utils/api";
import { teaserStatus } from "../../constants";

const ConfirmDialog = props => {
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [count, setCount] = useState("-");

  const {
    title,
    confirmAction,
    onConfirm,
    globalCheck,
    ids,
    search,
    ...rest
  } = props;

  const realTitle = `${title}: ${count}`;

  const statusMap = {
    start: teaserStatus.active,
    stop: teaserStatus.inactive,
    delete: teaserStatus.delete
  };

  const status = statusMap[confirmAction];

  const params = { globalCheck, ids, search, status };

  useEffect(() => {
    setLoading(true);

    TeasersCountService(params)
      .then(data => {
        setLoading(false);
        setCount(data.count);
      })
      .catch(e => {
        console.log(e);
      });
  }, []);

  const handleConfirm = () => {
    setLoading(true);
    setConfirmLoading(true);

    BatchStatusChangeService(params)
      .then(() => {
        onConfirm();
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <ConfirmModal
      {...rest}
      loading={loading}
      confirmLoading={confirmLoading}
      title={realTitle}
      onConfirm={handleConfirm}
    />
  );
};

export default ConfirmDialog;
